import { gooruSearchAPI } from '@/providers/apis/gooru-search/gooru-search';
import { independentStudyApi } from '@/providers/apis/independent-study/independent-study';
import { markersAPI } from '@/providers/apis/markers/markers';
import { mediaAPI } from '@/providers/apis/media/media';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { sessionService } from '@/providers/services/auth/session';
import { checkCDNUrl, isEmptyValue, sortByProperty } from '@/utils/utils';
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import SuccessPopupComponent from '../success-popup/success-popup';
import { INDEPENDENT_POPUP_CONTENT } from '@/utils/constants';
@Component({
    name: 'create-independent-program',
    components: {
        'success-popup': SuccessPopupComponent,
    },
})


export default class CreateIndependentProgram extends Vue {
    @Provide('validator') public $validator: any = this.$validator;
    public viewMode = false;
    public showPopup = false;
    public isConfirm: boolean = false;
    public errors: any;
    @Prop()
    public selectedProgram: any;
    public contentTitle: string | undefined;
    @Prop()
    public isEditing: any;
    // public programType = ['Free', 'Paid']
    public programType = [
        { value: 'Free', text: 'Free' },
        { value: 'Paid', text: 'Paid' },
    ];
    public imagePreview: any = '';
    @Prop()
    public filterItems: any;
    public isEnableMarker: any = false;
    public activeSettings: any = {};
    public productList: any = [];
    @Prop()
    public countryList: any;
    @Prop()
    public classification: any;
    public latestGradesList: any = [];
    public latestCourseList: any = [];
    public latestMarkerList: any = [];
    public selectedSubjectTitle: any = '';
    public selectedCategoryTitle: any = '';
    public uploadedImage: any;
    public isGradeWiseCources: boolean = false;
    public enableMarkerData: any = [];
    public isGradeWiseMarker: boolean = false;
    public isViewMode: any;
    public showSuccessMessage: boolean = false;
    public contentBody: any;
    public buttonTitle: any;
    public subscriptionValidity = ['30 days', '60 days', '90 days'];
    public currency = ['USD', 'Dollar', 'Rupees'];
    public contentItems: any = {
        categories: {
            label: 'Select Cateogry',
            items: [],
            selectedItems: [],
            key: 'categories',
            fieldType: 'b-form-select',
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            validate: { required: true },
            event: {
                change: this.onChangeCategories,
            },
        },
        subjects: {
            label: 'Select Subject',
            items: [],
            selectedItems: [],
            key: 'subjects',
            fieldType: 'b-form-select',
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            validate: { required: true },
            event: {
                change: this.onSelectSubject,
            },
        },
        frameworks: {
            label: 'Select Framework',
            items: [],
            selectedItems: [],
            key: 'frameworks',
            fieldType: 'b-form-select',
            validate: { required: true },
            options: {
                'text-field': 'title',
                'value-field': 'taxonomy_subject_id',
            },
            event: {
                change: this.onChangeFramework,
            },
        },
        grades: {
            label: 'Select Grade',
            items: [],
            selectedItems: [],
            key: 'grades',
            fieldType: 'b-form-select',
            validate: { required: true },
            options: {
                'text-field': 'grade',
                'value-field': 'id',
            },
            event: {
                change: this.onChangeGrade,
            },
        },
        lower_grades: {
            label: 'Select LowerGrade',
            items: [],
            selectedItems: [],
            key: 'lower_grade',
            fieldType: 'b-form-select',
            validate: { required: true },
            options: {
                'text-field': 'grade',
                'value-field': 'id',
            },
        },
        audience: {
            label: 'Audience',
            items: [{
                name: 'Student',
                key: '{student}',
            },
            {
                name: 'Teacher',
                key: '{teacher}',
            }],
            selectedItems: '',
            key: 'audience',
            validate: { required: true },
            fieldType: 'b-form-select',
            options: {
                'text-field': 'name',
                'value-field': 'key',
            },
        },
        diagnostic_applicable: {
            label: 'Diagnostic applicable',
            items: [],
            selectedItems: false,
            key: 'diagnosticApplicable',
            fieldType: 'b-form-checkbox',
            validate: { required: true },
            options: {
                switch: true,
            },
        },
    };
    public formData: any = {
        courseTitle: '',
        courseDescription: '',
        courseShortDescription: '',
        product: '',
        referenceId: '',
        lower_grades: '',
        subjects: '',
        frameworks: '',
        audience: '',
        country: '',
        programType: 'Free',
        currency: '',
        price: '',
        subscriptionValidity: '',
        images: null,
    };

    public openPopup() {
        this.showPopup = true;
    }
    public closePopup() {
        this.showPopup = false;
        if (!this.isConfirm) {
            // this.defaultFormData();
            this.$emit('goBack');
        }
    }
    public async createProgram() {
        this.isConfirm = false;
        this.showPopup = false;
        this.contentTitle = INDEPENDENT_POPUP_CONTENT.confirmSuccess.title;
        this.contentBody = INDEPENDENT_POPUP_CONTENT.confirmSuccess.description
        .replace('[Course Title]', this.formData.courseTitle);
        this.buttonTitle = INDEPENDENT_POPUP_CONTENT.confirmSuccess.buttonName;
        this.showPopup = true;
        await independentStudyApi.createNavigatorProgram(this.formData);
        independentStudyApi.indexProgram();
    }
    public async publish() {
        if (this.contentItems) {
            this.formData.audience = this.contentItems.audience.selectedItems;
            this.formData.framework = this.contentItems.frameworks.selectedItems;
            this.formData.grade = this.contentItems.grades.selectedItems;
            this.formData.lowerGrade = this.contentItems.lower_grades.selectedItems;
            this.formData.isDiagnosticApplicable = this.contentItems.diagnostic_applicable.selectedItems;
            this.formData.category = {
                id: this.contentItems.categories.selectedItems,
                title: this.selectedCategoryTitle,
            };
            this.formData.subject = {
                id: this.contentItems.subjects.selectedItems,
                title: this.selectedSubjectTitle,
            };
        }
        const thumbnailImage = this.uploadedImage ? await this.uploadImage(this.uploadedImage) : null;
        this.formData.thumbnail = thumbnailImage;
        this.formData.images = {
            thumbnail: thumbnailImage,
        };
        this.$validator.validateAll().then((valid: any) => {
            if (valid) {
                this.contentTitle = INDEPENDENT_POPUP_CONTENT.success.title;
                this.contentBody = INDEPENDENT_POPUP_CONTENT.success.description;
                this.buttonTitle = INDEPENDENT_POPUP_CONTENT.success.buttonName;
                this.isConfirm = true;
                this.showPopup = true;
                // independentStudyApi.createNavigatorProgram(this.formData);
            }
        });
    }

    public previewThumbnail(event: any) {
        const file = event.target.files[0];
        this.uploadedImage = file;
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imagePreview = e.target.result; // Update preview image
                this.formData.thumbnail = e.target.result; // Update formData
            };
            reader.readAsDataURL(file);
        }
    }

    public onConfirm() {
        this.createProgram();
    }

    public onCancel() {
        this.closePopup();
    }
    @Watch('contentItems.frameworks.selectedItems')
    public changeFw(value: any) {
        this.getEnableMarker();
        this.isGradeWiseMarker = this.isEnableMarker;
    }

    @Watch('contentItems.categories.selectedItems', { deep: true })
    public onCategoryChange(newCategory: string[]) {
        if (newCategory.length && this.selectedProgram) { this.onChangeCategories(newCategory); }
    }

    @Watch('contentItems.subjects.selectedItems', { deep: true })
    public onSubjectChange(newSubject: string[], newCategory: string[]) {
        if (newSubject.length && this.selectedProgram) { this.onSelectSubject(); }
    }

    @Watch('contentItems.frameworks.selectedItems', { deep: true })
    public onFrameworkChange(newFramework: string[]) {
        if (newFramework && newFramework.length && this.selectedProgram) { this.onChangeFramework(); }
    }

    @Watch('contentItems.grades.selectedItems', { deep: true })
    public onGradeChange(newGrade: string[]) {
        if (this.selectedProgram) { this.onChangeGrade(newGrade); }
    }
    public goBack() {
        this.$emit('goBack');
        this.selectedProgram = null;
    }
    public async created() {
        this.activeSettings = await this.getTenantSettings();
        await this.fetchCategoryList();
        if (this.selectedProgram) {
            this.formData = {
                courseTitle: this.selectedProgram.title || '',
                courseDescription: this.selectedProgram.description || '',
                courseShortDescription: this.selectedProgram.shortDescription || '',
                product: this.selectedProgram.productId || '',
                referenceId: this.selectedProgram.referenceId || '',
                lower_grades: this.selectedProgram.gradeLower || '',
                frameworks: this.selectedProgram.framework || '',

                country: this.selectedProgram.country || '',
                programType: this.selectedProgram.programType || 'Free',
                currency: this.selectedProgram.currency || 'USD',
                price: this.selectedProgram.price || '',
                subscriptionValidity: this.selectedProgram.subscription || '30 days',
                thumbnail: this.selectedProgram.thumbnail || null,
            },
            this.contentItems.categories.selectedItems = this.selectedProgram.category &&
                this.selectedProgram.category.title || '';
            this.contentItems.countries.selectedItems = this.selectedProgram.country || '';
            this.contentItems.diagnostic_applicable.selectedItems = this.selectedProgram.diagnosticApplicable || false;
            this.selectedSubjectTitle = this.selectedProgram.subject && this.selectedProgram.subject.title || '';
            this.selectedCategoryTitle = this.selectedProgram.category && this.selectedProgram.category.title || '';
        }
    }


    public fetchCategoryList() {
        const contentDetails = this.contentItems;
        taxonomyAPI.fetchTaxonomyClassifications().then((categoryList: any) => {
            const { categories } = contentDetails;
            categories.items = categoryList;
        });
    }
    public fetchCountryList() {
        const contentDetails = this.contentItems;
        taxonomyAPI.fetchTaxonomyCountry().then((value: any) => {
            const { countries } = contentDetails;
            countries.items = value.groups;
        });
    }
    public async onChangeCategories(categoryCode: any) {
        this.contentItems.subjects.selectedItems = [];
        this.contentItems.frameworks.selectedItems = '';
        if (this.contentItems.frameworks) {
            this.contentItems.frameworks.selectedItems = [];
        }
        if (this.contentItems.grades) {
            this.contentItems.grades.selectedItems = [];
        }
        const catgegorySelected = this.contentItems.categories.items.find((cat: any) =>
            cat.id === categoryCode);
        this.getSubject(catgegorySelected.id);
        this.isGradeWiseCources = false;
    }
    public onChangeGrade(grade: any) {
        const gradeList = this.contentItems.grades.items;
        const currentGradeInfo = gradeList.find((item: any) => item.id === grade);
        const currentSequence = currentGradeInfo.sequence;
        const gradesBelowCurrent = gradeList.filter((item: any) => item.sequence <= currentSequence);
        this.contentItems.lower_grades.items = gradesBelowCurrent;
        this.contentItems.lower_grades.selectedItems = this.selectedProgram &&
         this.selectedProgram.gradeLower && this.selectedProgram.gradeLower || '';
    }

    public async getSubject(categoryId: string) {
        const contentDetails = this.contentItems;
        await taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            const { subjects } = contentDetails;
            subjects.items = subjectList;
        });
        this.contentItems.subjects.selectedItems = this.selectedProgram &&
         this.selectedProgram.subject && this.selectedProgram.subject.id || '';
    }

    public onSelectSubject(subjectId?: any, title?: any) {
        const cateogryOptions = this.contentItems;
        if (this.contentItems.frameworks) {
            this.contentItems.frameworks.selectedItems = [];
        }
        if (this.contentItems.grades) {
            this.contentItems.grades.selectedItems = [];
        }
        const { frameworks, subjects } = cateogryOptions;
        const activeSubject = subjects.items.find((subject: any) => subject.id === subjectId);
        frameworks.items = activeSubject ? activeSubject.frameworks : [];
        this.onSelectSubjectForGrdaes(subjectId);
        this.contentItems.frameworks.selectedItems = '';
        this.isGradeWiseCources = false;
    }

    public onSelectSubjectForGrdaes(subjectId: any) {
        const cateogryOptions = this.contentItems;
        const { grades, subjects } = cateogryOptions;
        const activeSubject = subjects.items.find((subject: any) => subject.id === subjectId);
        // taxonomyAPI.fetchTaxonomyGrades(activeSubject.id, 'GUT').then((courses) => {
        //     grades.items = courses ? courses : [];
        // });
    }
    public getEnableMarker() {
        this.isEnableMarker = false;
        if (!isEmptyValue(this.contentItems.frameworks.selectedItems)) {
            this.isEnableMarker = this.enableMarkerData.includes(this.contentItems.frameworks.selectedItems);
        }
        return this.isEnableMarker;
    }
    public onChangeMarker() {
        this.isGradeWiseMarker = this.contentItems.markers.selectedItems;
    }
    public getTenantSettings() {
        return tenantSettingsAPI.fetchActiveTenantSettings().then((settingsData: any) => {
            if (settingsData && settingsData.enable_marker) {
                this.enableMarkerData = settingsData.enable_marker;
            }
            if (settingsData && settingsData.navigator_class_setting) {
                return settingsData.navigator_class_setting;
            }
        });
    }
    public async onChangeFramework() {
        const subjectId = this.contentItems.subjects.selectedItems;
        const categoryCode = this.contentItems.categories.selectedItems;
        const fwSelected = this.contentItems.frameworks.selectedItems;
        this.isGradeWiseCources = false;
        this.checkCatSubTitle();
        if (fwSelected) {
            const fw = this.contentItems.frameworks.selectedItems.split('.');
            this.onSelectSubjectForGrdaesWithFWCode(subjectId, fw[0]);
            const fwIndexList = this.contentItems.frameworks.items.findIndex((item: any) =>
                item.taxonomy_subject_id === this.contentItems.frameworks.selectedItems);
            if (fwIndexList !== -1) {
                const fwObject = this.contentItems.frameworks.items[fwIndexList];

                this.latestCourseList = await this.getCoursesBySubject(this.contentItems.frameworks.selectedItems,
                     '*', fwObject.standard_framework_id);
                this.latestMarkerList = await this.searchMarkers(subjectId, fw[0]);
            }
        }
    }
    public async searchMarkers(subjectCode: any, fwCode: any) {
        const params: any = {
            filters: {
                'txFramework.fwCode': fwCode,
                'txSubject.txSubjectCode': subjectCode,
                'markerSource': 'grade',
            },
            offset: 0,
            limit: 20,
        };
        const marker = await markersAPI.searchMarkers(params);
        let markerList = [];
        sortByProperty(marker.markerList, 'sequence', 'ASC');
        markerList = marker.markerList;
        return markerList;
    }
    public getCoursesBySubject(selectedFw: any, qparam: any, selectedFwCode: any) {
        const parmas = {
            'q': qparam,
            'start': 1,
            'length': 70,
            'flt.courseType': 'featured',
            'flt.subject': selectedFw,
            'flt.frameworkCode': selectedFwCode,
        };
        return gooruSearchAPI.searchCoursesBySubject(parmas).then((courseData) => {
            return courseData.searchResults;
        });
    }
    public checkCatSubTitle() {
        const subjectId = this.contentItems.subjects.selectedItems;
        const categoryCode = this.contentItems.categories.selectedItems;
        const subject = this.contentItems.subjects.items.find((item: any) => item.id === subjectId);
        const category = this.contentItems.categories.items.find((item: any) => item.id === categoryCode);
        this.selectedSubjectTitle = subject.title;
        this.selectedCategoryTitle = category.title;
    }
    public async onSelectSubjectForGrdaesWithFWCode(subjectId: any, fwCode: any) {
        const cateogryOptions = this.contentItems;
        const { grades, subjects } = cateogryOptions;
        await taxonomyAPI.fetchTaxonomyGradesWithFwCode(subjectId, fwCode).then((gradeList) => {
            sortByProperty(gradeList, 'sequence', 'ASC');
            for (const iterator of gradeList) {
                iterator.selectedCourse = '';
            }
            grades.items = gradeList ? gradeList : [];
            this.latestGradesList = gradeList ? gradeList : [];
        });
        this.contentItems.grades.selectedItems = this.selectedProgram && this.selectedProgram.gradeCurrent &&
         this.selectedProgram.gradeCurrent || '';
    }
    public async uploadImage(iterator: any) {
        return mediaAPI.uploadFile(iterator, 'image').then((fileData) => {
            return checkCDNUrl(fileData.filename);
        });
    }

    public mounted() {
        const session: any = sessionService.getSession();
        const tennatid = session.tenant!.tenant_id;
        tenantSettingsAPI.fetchSubscribedProductList(tennatid).then((productList) => {
            this.productList = productList.data.list;
        });
        if (this.selectedProgram && this.selectedProgram.thumbnail) {
            this.imagePreview = this.selectedProgram.thumbnail;
        }
    }
}
